import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Navigation from "./components/layout/Navigation";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import LoadingScreen from "./components/ui/LoadingScreen";
import { SceneProvider } from "./context/SceneContext";
import GlobalCanvas from "./components/scene/GlobalCanvas";
import SceneHUD from "./components/scene/SceneHUD";
import SceneClickRegenerate from "./components/scene/SceneClickRegenerate";
import OperatorHUD from "./components/scene/OperatorHUD";

/* Smooth page enter/exit transition */
const PageTransition = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 14, filter: "blur(4px)" }}
    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    exit={{ opacity: 0, y: -10, filter: "blur(2px)" }}
    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

/* Inner component that can use useLocation (must be inside BrowserRouter) */
function AppContent() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
        <Route path="/projects" element={<PageTransition><ProjectsPage /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
        <Route path="*" element={<PageTransition><NotFoundPage /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <SceneProvider>
      <div className="App bg-[#0E1116] min-h-screen relative">
        <GlobalCanvas />
        <SceneClickRegenerate />
        <OperatorHUD />
        <LoadingScreen />
        <BrowserRouter>
          <Navigation />
          <SceneHUD />
          <AppContent />
        </BrowserRouter>
      </div>
    </SceneProvider>
  );
}

export default App;
